var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3627 11.659C17.4738 11.6589 16.6213 12.012 15.9926 12.6406C15.364 13.2691 15.0108 14.1216 15.0108 15.0105C15.0107 15.8995 15.3638 16.752 15.9924 17.3806C16.6209 18.0093 17.4734 18.3624 18.3623 18.3625C19.2513 18.3626 20.1038 18.0095 20.7324 17.3809C21.3611 16.7524 21.7142 15.8999 21.7143 15.0109C21.7144 14.122 21.3613 13.2695 20.7327 12.6408C20.1042 12.0122 19.2517 11.659 18.3627 11.659Z",
    fill: "url(#paint0_linear_56093_78695)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.72146 7.74766C2.72155 6.20436 3.97295 4.9546 5.51476 4.9547L31.2115 4.95626C32.7534 4.95635 34.0046 6.20775 34.0045 7.74955L34.0036 22.2738C34.0035 23.8171 32.7521 25.0669 31.2103 25.0668L5.51354 25.0652C5.14674 25.0652 4.78354 24.9929 4.44467 24.8526C4.1058 24.7122 3.7979 24.5064 3.53855 24.247C3.2792 23.9876 3.07347 23.6797 2.93313 23.3408C2.79278 23.0019 2.72056 22.6387 2.72058 22.2719L2.72146 7.74766ZM12.7763 15.0104C12.7764 13.5288 13.365 12.108 14.4127 11.0604C15.4604 10.0129 16.8813 9.42439 18.3629 9.42448C19.8444 9.42457 21.2653 10.0132 22.3129 11.0609C23.3604 12.1086 23.9489 13.5295 23.9488 15.0111C23.9487 16.4926 23.3601 17.9135 22.3124 18.9611C21.2647 20.0086 19.8438 20.5971 18.3622 20.597C16.8806 20.5969 15.4598 20.0083 14.4122 18.9606C13.3647 17.9129 12.7762 16.492 12.7763 15.0104ZM28.4179 13.8941C28.1216 13.8941 27.8374 14.0118 27.6278 14.2213C27.4183 14.4308 27.3006 14.715 27.3006 15.0113L27.3006 15.0232C27.3005 15.6399 27.801 16.1405 28.4177 16.1405L28.4297 16.1405C28.726 16.1405 29.0102 16.0228 29.2197 15.8133C29.4292 15.6038 29.547 15.3197 29.547 15.0233L29.547 15.0114C29.547 14.7151 29.4293 14.4309 29.2198 14.2214C29.0103 14.0118 28.7261 13.8941 28.4298 13.8941L28.4179 13.8941ZM7.19002 15.0101C7.19004 14.7138 7.30777 14.4296 7.51731 14.2201C7.72685 14.0106 8.01103 13.8929 8.30734 13.8929L8.31926 13.8929C8.61558 13.8929 8.89975 14.0106 9.10926 14.2202C9.31877 14.4297 9.43646 14.7139 9.43645 15.0102L9.43645 15.0221C9.43643 15.3184 9.3187 15.6026 9.10916 15.8121C8.89962 16.0216 8.61544 16.1393 8.31913 16.1393L8.30721 16.1393C8.01089 16.1393 7.72672 16.0216 7.51721 15.812C7.3077 15.6025 7.19001 15.3183 7.19002 15.022L7.19002 15.0101Z",
    fill: "url(#paint1_linear_56093_78695)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.83752 27.2996C3.54121 27.2996 3.25703 27.4173 3.04749 27.6268C2.83795 27.8363 2.72022 28.1205 2.7202 28.4168C2.72019 28.7131 2.83788 28.9973 3.04739 29.2069C3.2569 29.4164 3.54108 29.5341 3.83739 29.5341C11.8816 29.5346 19.6725 30.6106 27.076 32.6266C28.8487 33.1094 30.6513 31.7956 30.6514 29.9156L30.6515 28.4185C30.6515 28.1222 30.5338 27.838 30.3243 27.6285C30.1148 27.4189 29.8306 27.3012 29.5343 27.3012L3.83752 27.2996Z",
    fill: "url(#paint2_linear_56093_78695)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_56093_78695",
    x1: 19.5116,
    y1: 3.88732,
    x2: 19.0033,
    y2: 32.9904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.971011,
    stopColor: "white",
    stopOpacity: 0.68
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_56093_78695",
    x1: 19.5116,
    y1: 3.88732,
    x2: 19.0033,
    y2: 32.9904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.971011,
    stopColor: "white",
    stopOpacity: 0.68
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_56093_78695",
    x1: 19.5116,
    y1: 3.88732,
    x2: 19.0033,
    y2: 32.9904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.971011,
    stopColor: "white",
    stopOpacity: 0.68
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.c2cd8f52b07ffe07396e899ca9ec7f35.svg";
export { ForwardRef as ReactComponent };